/* global ReactSpringserveComponent */

angular.module("vastdesk").component("bulkBudgetChangeModal", {
  bindings: {
    type: "@",
    targetTableId: "@",
  },
  template: require("../templates/bulkBudgetChangeModal.html"),
  controllerAs: "$bulkBudgetChangeModalCtrl",
  controller: [
    "$scope",
    "$rootScope",
    function ($scope, $rootScope) {
      const self = this;

      this.rootId = `component-root-angular-ModalBulkBudgetChange-${Math.floor(
        Math.random() * 2 ** 52
      )}`;

      this.open = false;
      this.selectedIds = [];
      this.unregisterWatcher = null;

      this.handleBulkBudgetChangeModalOpenChange = (open) => {
        self.open = open;
        $scope.$apply();
      };

      this.handleBulkBudgetChangeSubmitted = () => {
        $scope.$apply();
        location.reload();
      };

      this.renderReactComponent = () => {
        return window.reactComponentScriptLoaded.promise.then(() => {
          ReactSpringserveComponent.renderComponent({
            componentName: "ModalBulkBudgetChange",
            rootId: self.rootId,
            componentProps: {
              open: self.open,
              setOpen: self.handleBulkBudgetChangeModalOpenChange,
              onBulkBudgetChangeSubmitted: self.handleBulkBudgetChangeSubmitted,
              type: self.type,
              selectedIds: self.selectedIds,
            },
          });
        });
      };

      this.$onInit = () => {
        self.renderReactComponent().then(() => {
          self.unregisterWatcher = $scope.$watchGroup(
            [
              "$bulkBudgetChangeModalCtrl.open",
              "$bulkBudgetChangeModalCtrl.selectedIds",
            ],
            ([_open, _selectedIds]) => {
              self.renderReactComponent();
            }
          );
        });
      };

      this.$onDestroy = () => {
        if (self.unregisterWatcher) {
          self.unregisterWatcher();
        }
      };

      $rootScope.$on("bulkEditBroadcast", (event, args) => {
        if (
          args.tableId === self.targetTableId &&
          args.id === "budget_change"
        ) {
          // copy the selected id array to guard against us accidentally clobbering it in a way that would break the AngularJS side
          self.selectedIds = Array.isArray(args.selectedIds)
            ? args.selectedIds.slice()
            : [];
          self.open = true;
        }
      });
    },
  ],
});
